import Base from "./base.service.js";
export default class JobStatus extends Base {
    constructor() {
        super("status-job");
    }
}
